import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST, PUT} from '../../../services/api'
import {i18n} from '../../../translate/i18n'
import Swal from 'sweetalert2'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'
import {Input} from '../../../components/Input/Input'
import moment from 'moment'
import {Button} from '../../../components/Button/Button'
import {formatPhone, telephoneNoMask, toDate, toDateTime} from '../../../utils/formater'
import styles from './report-management.module.css'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import useAuth from '../../../hooks/useAuth'

type BookingResponseType = {
  id: string
  date: string
  bookingHour: {hour: string}
  people: number
  name: string
  phone: string
  finalized: null | 'confirmed' | 'canceled' | 'noShow'
  bookingConfigId: string
  bookingEnvironment: {name: string}
  createdAt: string
}

type BookingType = {
  id: string
  date: string
  hour: string
  people: number
  name: string
  phone: string
  finalized: null | 'confirmed' | 'canceled' | 'noShow'
  bookingConfigId: string
  bookingEnvironment: {name: string}
  created: string
  accessibilityNeeds?: 'Apoio ao Idoso' | 'Cadeirante' | 'Deficiente Físico' | null
}

const BookingReportManagementDetailContent: FC = () => {
  const navigate = useNavigate()
  const {search} = useParams()
  const {showWrapperModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'))
  const [finalDate, setFinalDate] = useState(moment().format('YYYY-MM-DD'))
  const [bookingsTomorrow, setBookingsTomorrow] = useState<BookingType[]>([])
  const [bookingSelected, setBookingSelected] = useState<BookingType | null>(null)
  const [phone, setPhone] = useState('')
  const [gmt, setGmt] = useState<string>('')
  const {loginInfo} = useAuth()

  const getGMT = async () => {
    try {
      setLoading(true)

      const resGMT = await GET(`pluginspace/${loginInfo.pluginspaceId}`)

      const gmt = resGMT.data[0].gmt

      setGmt(gmt)

      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const getBookings = async () => {
    try {
      const res = await GET('/queueReservation/bookingConfig')
      if (res.success && res.data && res.data[0] && res.data[0].id) {
        const objSearch: any = {}

        if (search && window.atob(search) && JSON.parse(window.atob(search))) {
          Object.entries(JSON.parse(window.atob(search))).forEach((obj) => {
            if (obj[1] && obj[1] !== '') {
              objSearch[obj[0]] = obj[1]
            }
          })
          if (objSearch.initialDate)
            setStartDate(
              objSearch.initialDate.includes(' ')
                ? objSearch.initialDate.split(' ')[0]
                : objSearch.initialDate
            )
          if (objSearch.finalDate)
            setFinalDate(
              objSearch.finalDate.includes(' ')
                ? objSearch.finalDate.split(' ')[0]
                : objSearch.finalDate
            )
          if (objSearch.phone) setPhone(objSearch.phone)
        }
        objSearch.bookingConfigId = res.data[0].id
        const bookingTomorrowRes = await POST('/queueReservation/booking/filter', objSearch)
        if (bookingTomorrowRes && bookingTomorrowRes.data) {
          setBookingsTomorrow(
            bookingTomorrowRes.data.map((booking: BookingResponseType) => {
              return {
                id: booking.id,
                name: booking.name,
                date: booking.date,
                hour: booking.bookingHour.hour,
                people: booking.people,
                phone: formatPhone(booking.phone),
                finalized: booking.finalized,
                bookingConfigId: booking.bookingConfigId,
                bookingEnvironment: booking.bookingEnvironment,
                created: toDateTime(booking.createdAt),
              }
            })
          )
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Não foi possível encontrar configuração de reserva',
        }).then(() => navigate('/booking/config'))
      }
    } catch (e) {
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao encontrar reservas, verifique as configurações.',
      }).then(() => navigate('/booking/config'))
    }
  }

  const tratarData = (criado: string) => {
    const dateHour = criado.split(' ')
    console.log(dateHour)

    const data = dateHour[0]
    const hora = dateHour[1]

    const dataTransform = new Date(data)
    let startDateTransform = data
    let horaInitTransform = hora.slice(0, 2)
    let verificaDigito = parseInt(horaInitTransform)
    const gmtParse = parseInt(gmt)

    if (gmtParse < 0) {
      //Tratar 23
      if (verificaDigito < 21) {
        verificaDigito += gmtParse
        horaInitTransform = verificaDigito.toString().padStart(2, '0') + hora.substring(2)
      } else {
        switch (horaInitTransform) {
          case '21':
            horaInitTransform = '00'
            break
          case '22':
            horaInitTransform = '01'
            break
          case '23':
            horaInitTransform = '02'
            break
        }

        dataTransform.setDate(dataTransform.getDate() + 2)
        if (dataTransform.getDate() === 1) dataTransform.setMonth(dataTransform.getMonth() + 1)
        if (dataTransform.getMonth() === 0)
          dataTransform.setFullYear(dataTransform.getFullYear() + 1)
        startDateTransform = `${dataTransform.getFullYear()}-${(dataTransform.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${dataTransform.getDate().toString().padStart(2, '0')}`
        horaInitTransform = horaInitTransform + hora.substring(2)
      }
    } else if (gmtParse > 0) {
      //Tratar 00
      if (verificaDigito > 2) {
        verificaDigito += gmtParse
        horaInitTransform = verificaDigito.toString().padStart(2, '0') + hora.substring(2)
      } else {
        switch (horaInitTransform) {
          case '00':
            horaInitTransform = '21'
            break
          case '01':
            horaInitTransform = '22'
            break
          case '02':
            horaInitTransform = '23'
            break
        }

        dataTransform.setDate(dataTransform.getDate() - 2)
        if (dataTransform.getDate() === 1) dataTransform.setMonth(dataTransform.getMonth() - 1)
        if (dataTransform.getMonth() === 0)
          dataTransform.setFullYear(dataTransform.getFullYear() - 1)
        startDateTransform = `${dataTransform.getFullYear()}-${(dataTransform.getMonth() - 1)
          .toString()
          .padStart(2, '0')}-${dataTransform.getDate().toString().padStart(2, '0')}`
        horaInitTransform = horaInitTransform + hora.substring(2)
      }
    } else {
      horaInitTransform = hora
      startDateTransform = data
    }
    return startDateTransform + ' ' + horaInitTransform
  }

  const cancelBooking = async () => {
    if (bookingSelected) {
      const booking = Object.assign(bookingSelected)
      setBookingSelected(null)
      try {
        setLoading(true)
        const res = await PUT(`/queueReservation/booking/${booking.id}`, {
          finalized: 'canceled',
          bookingConfigId: booking.bookingConfigId,
        })
        setLoading(false)
        if (res && res.success) {
          Swal.fire({
            icon: 'success',
            title: 'Reserva cancelada!',
          }).then(async () => await init())
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: 'Falha ao alterar reserva',
          }).then(async () => await init())
        }
      } catch (e: any) {
        setLoading(false)
        console.log(e)
        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: e ? e : 'Falha ao alterar reserva',
        }).then(async () => await init())
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao alterar reserva',
      }).then(async () => await init())
    }
  }

  const selectTime = async (time: string) => {
    switch (time) {
      case 'week':
        const nowDate = new Date()
        const dayWeek = nowDate.getDay()
        const initialDateWeek = new Date()
        initialDateWeek.setDate(nowDate.getDate() - dayWeek)
        const finalDateWeek = new Date()
        finalDateWeek.setDate(nowDate.getDate() + (6 - dayWeek))
        setStartDate(initialDateWeek.toISOString().split('T')[0])
        setFinalDate(finalDateWeek.toISOString().split('T')[0])
        const searchObj = {
          initialDate: initialDateWeek.toISOString().split('T')[0],
          finalDate: finalDateWeek.toISOString().split('T')[0],
          phone: telephoneNoMask(phone),
        }
        const search = window.btoa(JSON.stringify(searchObj))
        navigate(`/booking/management/${search}`)
        window.location.reload()
        break
      case 'month':
        const nowMonth = new Date().getMonth() + 1
        const nowYear = new Date().getFullYear()
        const initialDateMonth = `${nowYear}-${nowMonth < 10 ? `0${nowMonth}` : nowMonth}-01`
        let finalDateMonth = `${nowYear}-${
          nowMonth + 1 < 10 ? `0${nowMonth + 1}` : nowMonth + 1
        }-01`
        if (nowMonth >= 12) {
          finalDateMonth = `${nowYear + 1}-01-01`
        }
        setStartDate(initialDateMonth)
        setFinalDate(finalDateMonth)
        const searchObjMonth = {
          initialDate: initialDateMonth,
          finalDate: finalDateMonth,
          phone: telephoneNoMask(phone),
        }
        const searchMonth = window.btoa(JSON.stringify(searchObjMonth))
        navigate(`/booking/management/${searchMonth}`)
        window.location.reload()
        break
      case 'year':
        const year = new Date().getFullYear()
        const initialDateYear = `${year}-01-01`
        const finalDateYear = `${year + 1}-01-01`
        setStartDate(initialDateYear)
        setFinalDate(finalDateYear)
        const searchObjYear = {
          initialDate: initialDateYear,
          finalDate: finalDateYear,
          phone: telephoneNoMask(phone),
        }
        const searchYear = window.btoa(JSON.stringify(searchObjYear))
        navigate(`/booking/management/${searchYear}`)
        window.location.reload()
        break
      default:
        await init()
    }
  }

  const init = async () => {
    setLoading(true)
    await getBookings()
    await getGMT()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='d-flex flex-row gap-5 flex-wrap '>
          <div className='card w-100 d-flex flex-column'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`booking_report_management.management`)}
                </span>
                <BreadCrumbs />
              </h3>
            </div>
            <div
              className='d-flex flex-row justify-content-between align-items-center px-4 py-2'
              style={{borderBottom: '1px solid #B5B5C3'}}
            >
              <p style={{color: '#434349', fontSize: 14, margin: 0}}>
                {i18n.t(`booking_report.time`)}
              </p>
              <div className='d-flex flex-row gap-6 flex-wrap'>
                <Button
                  color='primary'
                  text={i18n.t(`booking.week`)}
                  click={() => selectTime('week')}
                  btnClass='h-45px mt-6'
                />
                <Button
                  color='primary'
                  text={i18n.t(`booking.month`)}
                  click={() => selectTime('month')}
                  btnClass='h-45px mt-6'
                />
                <Button
                  color='primary'
                  text={i18n.t(`booking.year`)}
                  click={() => selectTime('year')}
                  btnClass='h-45px mt-6'
                />
              </div>
            </div>
            <div className='d-flex flex-row justify-content-between align-items-center px-4 py-2'>
              <p style={{color: '#434349', fontSize: 14, margin: 0}}>
                {i18n.t(`booking_report_management.search`)}
              </p>
              <div className='d-flex flex-row gap-6 flex-wrap'>
                <div className='d-flex flex-row gap-2 align-items-center mb-6'>
                  <p className='mt-6' style={{color: '#71718B', fontSize: 14, margin: 0}}>
                    {i18n.t(`booking_report_management.phone`)}
                  </p>
                  <Input inputAttr={{type: 'tel'}} value={phone} change={setPhone} />
                </div>
                <div className='d-flex flex-row gap-2 align-items-center mb-6'>
                  <p className='mt-6' style={{color: '#71718B', fontSize: 14, margin: 0}}>
                    {i18n.t(`booking_report_management.date_start`)}
                  </p>
                  <Input
                    inputAttr={{type: 'date'}}
                    value={startDate}
                    change={setStartDate}
                    maxLength={finalDate}
                  />
                </div>
                <div className='d-flex flex-row gap-2 align-items-center mb-6'>
                  <p className='mt-6' style={{color: '#71718B', fontSize: 14, margin: 0}}>
                    {i18n.t(`booking_report_management.date_end`)}
                  </p>
                  <Input
                    inputAttr={{type: 'date'}}
                    value={finalDate}
                    change={setFinalDate}
                    minLength={startDate}
                  />
                </div>
                <Button
                  color='primary'
                  text={i18n.t(`buttons.search`)}
                  click={() => {
                    const search = window.btoa(
                      JSON.stringify({
                        initialDate: startDate,
                        finalDate,
                        phone: telephoneNoMask(phone),
                      })
                    )
                    navigate(`/booking/management/${search}`)
                    window.location.reload()
                  }}
                  btnClass='h-45px mt-6'
                />
              </div>
            </div>
          </div>

          <div className='d-flex flex-row gap-5 w-100'>
            <div className='card' style={{flex: 1}}>
              <div className='card-body d-flex flex-column gap-5'>
                <h2 style={{fontWeight: 400, fontSize: 16, color: '#2A2D36'}}>
                  {i18n.t(`booking_report_management.search_text`)}
                </h2>
                <div
                  className={`d-flex flex-column gap-2 p-2 `}
                  style={{border: '1px solid #EFF0FA', borderRadius: 4}}
                >
                  <div className={styles.booking} style={{borderBottom: '1px solid #EFF0FA'}}>
                    <b className={styles.bookingTitle}>DATA</b>
                    <b className={styles.bookingTitle}>HORA</b>
                    <b className={styles.bookingTitle}>PESSOAS</b>
                    <b className={styles.bookingTitle}>NOME</b>
                    <b className={styles.bookingTitle}>TELEFONE</b>
                    <b className={styles.bookingTitle}>AMBIENTE</b>
                    <b className={styles.bookingTitle}>CRIAÇÃO</b>
                    <b className={styles.bookingTitle}></b>
                    <b className={styles.bookingTitle}></b>
                  </div>
                  {bookingsTomorrow.map((booking) => (
                    <div className={styles.booking}>
                      <p className={styles.bookingText}>{toDate(booking.date)}</p>
                      <p className={styles.bookingText}>{booking.hour}</p>
                      <p className={styles.bookingText}>
                        {booking.people} {i18n.t(`booking_report_management.people`)}
                      </p>
                      <p className={styles.bookingText}>{booking.name}</p>
                      <p className={styles.bookingText}>{booking.phone}</p>
                      <p className={styles.bookingText}>{booking.bookingEnvironment.name}</p>
                      <p className={styles.bookingText}>{tratarData(booking.created)}</p>
                      <div className={booking.finalized ? styles[booking.finalized] : styles.open}>
                        {booking.finalized
                          ? i18n.t(`booking_report_management.${booking.finalized}`)
                          : i18n.t(`booking_report_management.open`)}
                      </div>
                      <button
                        onClick={() => {
                          if (booking.finalized !== 'canceled') {
                            setBookingSelected(booking)
                            showWrapperModal(i18n.t(`booking_day.cancel_title`))
                          } else {
                            Swal.fire({
                              icon: 'warning',
                              title: 'Reserva já cancelada!',
                            })
                          }
                        }}
                        style={{
                          borderRadius: '4px',
                          backgroundColor: '#5D8ED8',
                          width: 30,
                          height: 30,
                          border: 'none',
                        }}
                      >
                        <i style={{color: '#FFF'}} className='fa fa-times' aria-hidden='true'></i>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <ModalWrapper
            confirmAction={() => cancelBooking()}
            textAction={i18n.t(`booking_day.cancel_button`)}
          >
            {bookingSelected && (
              <div
                className='d-flex flex-row px-4 py-6 align-items-center'
                style={{
                  border: '1px solid #D3D9E8',
                  borderLeft: '4px solid #D3D9E8',
                  borderRadius: 4,
                }}
              >
                <div className='d-flex flex-column gap-2'>
                  <div className='d-flex flex-row gap-2'>
                    <b style={{color: '#2A2D36', margin: 0}}>{i18n.t(`booking_day.date`)}</b>
                    <p style={{color: '#6E7586', margin: 0}}>
                      {toDate(bookingSelected.date)} {bookingSelected.hour}
                    </p>
                  </div>
                  <b style={{color: '#2A2D36', marginRight: 0}}>
                    {bookingSelected.people} {i18n.t(`booking_day.people`)}
                  </b>
                  <p style={{color: '#6E7586', margin: 0}}>
                    <b style={{color: '#2A2D36'}}>{bookingSelected.name}</b>
                  </p>
                  <p style={{color: '#6E7586', margin: 0}}>{bookingSelected.phone}</p>
                </div>
              </div>
            )}
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const BookingReportManagementDetail: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`booking_report_management.management`),
            path: 'booking/management',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`booking_report_management.management`)}
      </PageTitle>
      <BookingReportManagementDetailContent />
    </>
  )
}

export {BookingReportManagementDetail}
